import * as PIXI from "pixi.js";
import ServiceLocator from "../../ServiceLocator";
import { game_side_type } from "./Player";


export default class ComicBubble extends PIXI.Container
{
    private _text: PIXI.Text = null;


    public constructor()
    {
        super();

        let comicBubble: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.comic_bubble.texture );
        comicBubble.anchor.set( 342/384, 180/182 );
        this.addChild( comicBubble );

        this._text = new PIXI.Text( "", { fontFamily: "asap_bold", fontSize: 30, fill: 0x474747 } );
        this._text.anchor.set( 0.5 );
        this._text.position.set( -77, -58 );
        this.addChild( this._text );
    }

    public setText( text: string, scaleX: number ): void
    {
        this._text.text = text;
        this._text.scale.x = scaleX;
    }

    public setPlayerSide( playerSide: game_side_type ): void
    {
        switch ( playerSide )
        {
            case game_side_type.SOUTH: { this.position.set( 319 - 10, 750 - 50 ); break; }
            case game_side_type.WEST: { this.position.set( 121 + 10, 280 - 50 ); break; }
            case game_side_type.NORTH: { this.position.set( 319 - 50, 102 - 10 ); break; }
            case game_side_type.EAST: { this.position.set( 509 - 10, 276 - 50 ); break; }
        }
    }
}
